import { getDataMapper, mapField } from "@/shared";

export const mapPaymentFiltersToServer = getDataMapper({
    from: mapField("range", (item) => item.from),
    to: mapField("range", (item) => item.to),
    tariff_id: mapField("tariff"),
    tariff_period: mapField("tariffPeriod"),
    is_completed: mapField("isCompleted", Number),
    is_not_completed: mapField("isNotCompleted", Number),
    is_first_payment: mapField("isFirstPayment", Boolean),
});
